import { RouteChrome } from '@/components/RouteChrome/types';

/**
 * Learner-facing Journeys/Productivity/Engagement path prefixes where the topbar search
 * doesn't apply — search is scoped to the Learning content library. Admin routes are
 * handled separately via isAdminRoute since they all share the `/admin` prefix.
 */
const HIDDEN_SEARCH_PATH_PREFIXES = [
  '/journey', // Journeys (Learning)
  '/tasks', // Tasks (Productivity)
  '/projects', // Tasks (Productivity)
  '/habits', // Habits (Productivity)
  '/my-surveys', // Surveys (Engagement)
  '/my-survey', // Survey details (Engagement)
  '/community', // Community (Engagement)
  '/team-meetings', // Meetings (Engagement)
  '/1on1s', // 1:1s (Engagement)
  '/praises', // Praise (Engagement)
  '/feedback', // Feedback (Engagement)
];

const matchesPrefix = (path: string, prefix: string) =>
  path === prefix || path.startsWith(`${prefix}/`);

export function getRouteChromeDefaults(asPath: string, isAdminRoute: boolean): RouteChrome {
  if (isAdminRoute) {
    return { search: false };
  }

  const pathname = asPath.split('?')[0];
  if (HIDDEN_SEARCH_PATH_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))) {
    return { search: false };
  }

  return {};
}
